import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

import { computed, defineAsyncComponent } from 'vue';
import * as _ from 'lodash';
import { device } from '@/components/modules/common/module';


export default /*#__PURE__*/_defineComponent({
  __name: 'Nested',
  props: {
    list: {},
    parentData: {}
  },
  setup(__props: any) {

const props = __props;



const getComponent = (name: any) => {
  if (!name) return;
  return defineAsyncComponent(
    () => import(`@/components/modules/${name}/${_.upperFirst(name)}.vue` )
  );

  //if(name == 'Section') return Section;
  //if(name == 'Header') return Header;

  //return markRaw(name);
};

return (_ctx: any,_cache: any) => {
  const _component_Nested = _resolveComponent("Nested", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (element, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: _normalizeClass(['module', { utils: element.data?.utils }]),
        style: _normalizeStyle({
          'max-width': _unref(device) === 'pc' ? element.data?.width : element.data?.width_m,
        })
      }, [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(element.name)), {
            ref_for: true,
            ref: element.id,
            element: element,
            parentData: _ctx.parentData
          }, null, 8, ["element", "parentData"]))
        ], 1024)),
        (element.modules)
          ? (_openBlock(), _createBlock(_component_Nested, {
              key: 0,
              list: element.modules,
              parentData: _ctx.parentData,
              class: _normalizeClass(['module-child', element.data?.className ? element.data?.className : ''])
            }, null, 8, ["list", "parentData", "class"]))
          : _createCommentVNode("", true)
      ], 6))
    }), 128))
  ]))
}
}

})